var BaseGeneralAppConfigView = require("./BaseGeneralAppConfigView");
var Utils = require("common/Utils");

/**
 * @extends {BaseGeneralAppConfigView}
 * @constructor
 */
function GeneralAppConfigView() {
    BaseGeneralAppConfigView.call(this);
}

Utils.inherits(GeneralAppConfigView, BaseGeneralAppConfigView);

module.exports = GeneralAppConfigView;


//////////////////
// WEBPACK FOOTER
// ./settings/GeneralAppConfigView.js
// module id = 88
// module chunks = 0 3